<template>
    <el-row>
        <el-col :span="12" :offset="6">
            <div>
                <h1>Email notifications for maximum license reached</h1>
                <el-form status-icon label-width="200px" class="demo-ruleForm">
                    <el-form-item label="Enable E-Mail notifications">
                        <el-switch v-model="notifications.enabled"></el-switch>
                    </el-form-item>
                    <el-form-item label="Notify at">
                        <el-input-number input-size="large" :min="50" :max="200" v-model="notifications.percentage"/>
                        %
                    </el-form-item>
                  <!--  <el-form-item label="Notify max. every">
                        <el-input-number input-size="large" :min="1" :max="100" v-model="notifications.days"/>
                        Days
                    </el-form-item>-->
                    <el-form-item label="Email">
                        <el-input v-model="notifications.email"/>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">Save</el-button>
                        <el-button @click="loadData">Cancel</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-col>
    </el-row>
</template>

<style>


</style>

<script>
    import {SaveSettings, LoadSettings} from '../api.js'

    export default {
        name: "Settings",
        props: {},
        data: function() {
            return {
                notifications: {
                    enabled: true,
                    percentage: 100,
                    email: ''
                }
            }
        },
        methods: {
            async onSubmit() {
                const result = await SaveSettings(this.notifications);
                if(result === "OK"){
                    this.$message({
                        message: 'Settings saved.',
                        type: 'success'
                    });
                }
            },
            async loadData() {
                this.notifications = await LoadSettings();
            }
        },
        mounted() {
            this.loadData();
        }
    }

</script>